// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a759199e","239":"23981d0e","732":"79293969"}[chunkId] + ".chunk.js";
};